'use client';

import { useState } from 'react';
import { BlogPost, BlogTag } from '@/lib/blog';
import { Locale } from '@/lib/i18n';
import { BlogCard } from '@/components/blog/BlogCard';
import { TagFilter } from '@/components/blog/TagFilter';
import styles from './BlogOverview.module.css';

interface BlogOverviewProps {
  posts: BlogPost[];
  tags: BlogTag[];
  locale: Locale;
  messages: any;
}

export function BlogOverview({ posts, tags, locale, messages }: BlogOverviewProps) {
  const [selectedTag, setSelectedTag] = useState<BlogTag | null>(null);

  // Filter posts by selected tag
  const filteredPosts = selectedTag
    ? posts.filter((post) => post.metadata.tags.includes(selectedTag))
    : posts;

  return (
    <div className={styles.container}>
      {/* Tag Filter */}
      {tags.length > 0 && (
        <TagFilter
          tags={tags}
          selectedTag={selectedTag}
          onSelectTag={setSelectedTag}
          allPostsLabel={messages.allPosts}
        />
      )}

      {/* Posts Grid */}
      {filteredPosts.length > 0 ? (
        <div className={styles.grid}>
          {filteredPosts.map((post) => (
            <BlogCard
              key={post.metadata.slug}
              post={post}
              locale={locale}
              readTimeLabel={messages.readTimeLabel}
            />
          ))}
        </div>
      ) : (
        <div className={styles.noPosts}>
          <p>{messages.noPosts || 'No posts found for this tag.'}</p>
        </div>
      )}
    </div>
  );
}

